import React from "react";
import { Dialog, Divider, Typography } from "@mui/material";
import { Box } from "@mui/material";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Button from "@mostrans/web-components/components/base/Button";
import { toastError, toastSuccess } from "./../../../../../../shared/helpers";
import { UpdateCandidateAdditionalInformation } from "../../../../../../graphql/mutations";
import { useApolloClient } from "@apollo/client";
import { getCandidateByID } from "./../../../../../../graphql/query";
import { useSetRecoilState } from "recoil";
import { globalLoadingAtom } from "../../../../../../shared/globalStates";

const ModalAdditionalInfo = (props) => {
  const { openModal, modalClose, inputData, values, onChangeInput, setData } = props;
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const client = useApolloClient();

  function disableButton() {
    let arrValues = [];
    for (const key in values) {
      if (typeof values[key] === "object") {
        arrValues.push(values[key]?.includes(""));
      }
      arrValues.push(values[key] === "");
    }
    return arrValues?.includes(true) || arrValues.length === 0;
  }

  function inputValue() {
    return {
      curr_salary: parseInt(values.curr_salary),
      curr_benefits: values.curr_benefits,
      expected_salary: parseInt(values.expected_salary),
      expected_benefits: values.expected_benefits,
    };
  }

  async function updateAdditionalInfo() {
    setLoading(true);
    try {
      const response = await UpdateCandidateAdditionalInformation(client, inputValue());
      if (response.status === "000") {
        toastSuccess("Edit Additional Information Success");
        modalClose();
        getCandidateByID(client).then(setData);
      } else {
        toastError();
      }
    } catch (error) {
      toastError();
    }
    setLoading(false);
  }

  return (
    <Dialog open={openModal} onClose={modalClose} sx={{ width: "100%" }}>
      <Box>
        <Box p={2}>
          <Typography variant="h4">ADDITIONAL INFO</Typography>
        </Box>
        <Divider />
        <div className="row m-2">
          {inputData.map((item, id) => {
            const { name, nama, type, placeholder, textArea } = item;
            return (
              <div className="col-lg-6 font-size-main" key={id}>
                <FormGroup
                  label={nama}
                  errorMessage={"This field is required"}
                  isError={!values[name]}
                  isRequired>
                  <Input
                    name={name}
                    type={type}
                    multiline={textArea}
                    value={
                      name.includes("benefits")
                        ? values[name]?.join().replaceAll(",", "\n")
                        : values[name]
                    }
                    placeholder={placeholder}
                    onChange={(e) =>
                      onChangeInput(
                        name,
                        name.includes("benefits") ? e.target.value.split("\n") : e.target.value
                      )
                    }
                    style={{ resize: "none" }}
                  />
                </FormGroup>
              </div>
            );
          })}
        </div>
        <Divider />
        <div className="btn-action text-right m-2 ">
          <Button
            onClick={modalClose}
            variant="outlined"
            color="danger"
            style={{ margin: "0 10px" }}>
            Cancel
          </Button>
          <Button
            disabled={disableButton()}
            onClick={() => updateAdditionalInfo()}
            style={{ margin: "0 10px" }}>
            Save
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default ModalAdditionalInfo;
